<template>
  <div>
    <div class="gantt-chart">
      <div class="gantt-chart__labels">
        <div
          class="gantt-chart__label"
          v-for="(col, i) in cols"
          :key="`header-${i}`"
        >
          <div class="gantt-chart__text">
            {{ i + 1 }}
          </div>
        </div>
      </div>

      <div class="gantt-chart__labels">
        <div class="gantt-chart__label" v-for="col in cols" :key="col.key">
          <div class="gantt-chart__text">
            {{ col.title }}
          </div>
        </div>
      </div>

      <div
        class="gantt-chart__workspace"
        :style="`width: ${(cols.length + 3) * 110}px`"
      >
        <div
          class="gantt-chart__separators"
          :style="`height: ${
            isMultiple
              ? rows.reduce((total, r) => total + r.length, 0) * 40
              : rows.length * 40
          }px`"
        >
          <div
            class="gantt-chart__separator"
            v-for="col in cols"
            :key="col.key"
          ></div>
          <div
            class="gantt-chart__separator"
            v-for="i in 1"
            :key="`separator-${i}`"
          ></div>
        </div>
        <div class="gantt-chart__rows">
          <div
            :class="
              isMultiple ? 'gantt-chart__row_multiple' : 'gantt-chart__row'
            "
            :style="isMultiple ? `height:${row.length * 40}px` : ''"
            v-for="row in rows"
            :key="row.key"
          >
            <b-tooltip v-if="!isMultiple" :target="row.key">
              {{ row.title }}
            </b-tooltip>
            <div
              v-if="!isMultiple"
              class="gantt-chart__bar"
              @click="$emit('click', row)"
              :style="`width:${row.width * multiplier - 6}px; left: ${
                row.left * multiplier + 3
              }px;`"
              :id="row.key"
            >
              <div class="gantt-chart__number" v-if="row.number">
                {{ row.number }}
              </div>
              <div
                class="gantt-chart__text"
                :class="row.number != null ? 'gantt-chart__padding_number' : ''"
              >
                {{ row.title }}
              </div>
            </div>

            <template v-if="isMultiple">
              <div
                :id="r.key"
                v-for="(r, i) in row"
                :key="r.key"
                :class="`bg-gradient-${r.variant} `"
                class="gantt-chart__bar gantt-chart__bar_multiple"
                @click="
                  !r.buttonAdd && !r.desabilitarClick ? emitirCLick(r) : null
                "
                :style="`width:${r.width * multiplier - 6}px; left: ${
                  r.left * multiplier + 3
                }px; margin-top:${i == 0 ? 10 : 10 + i * 35}px;`"
              >
                <div class="gantt-chart__number" v-if="r.number">
                  {{ r.number }}
                </div>
                <b-tooltip :target="r.key">
                  {{ r.title }}
                </b-tooltip>
                <div
                  class="gantt-chart__text"
                  :class="
                    row.number != null ? 'gantt-chart__padding_number' : ''
                  "
                >
                  {{ r.title }}
                </div>
                <b-button
                  v-if="r.buttonAdd"
                  variant="transparent-info"
                  @click="emitirCLickBtn($event, r)"
                  size="sm"
                  class="btn"
                >
                  <i class="fa-solid fa-plus"></i>
                  <span>Realizar etapa</span>
                </b-button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GanttChart",
  emits: ["click"],
  props: {
    cols: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    multiplier: 120,
  }),
  methods: {
    getColor: function () {
      return "#" + Math.floor(Math.random() * 16777215).toString(16);
    },
    emitirCLickBtn: function (e, row) {
      e.stopPropagation();
      this.$emit("click", row);
    },
    emitirCLick: function (row) {
      this.$emit("click", row);
    },
  },
};
</script>
<style lang="scss">
.gantt-chart {
  border: 1px solid #e5e5e5;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}

.gantt-chart__workspace {
  position: relative;
  overflow-x: hidden;
  min-height: 400px;
}

.gantt-chart__labels {
  display: flex;
  flex-direction: row;
}

.gantt-chart__label {
  min-width: 120px;
  height: 30px;
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
}

.gantt-chart__label:last-child {
  border-right: none;
}

.gantt-chart__separators {
  display: flex;
  flex-direction: row;
  flex: 1;
  position: absolute;
}

.gantt-chart__separator {
  border-right: 1px solid #e5e5e5;
  min-width: 120px;
  max-width: 120px;
  width: 120px;
}

.gantt-chart__separator:last-child {
  border-right: none;
}

.gantt-chart__rows {
  position: absolute;
  width: calc(120px * 48);
}

.gantt-chart__row {
  height: 40px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
}

.gantt-chart__row_multiple {
  border-bottom: 1px solid #e5e5e5;
}

.gantt-chart__row_multiple:nth-child(odd) {
  background: #e5e5e54f;
}

.gantt-chart__row:nth-child(odd) {
  background: #e5e5e54f;
}

.gantt-chart__row_multiple .gantt-chart__bar {
  /*position: inherit !important;*/
}

.gantt-chart__bar {
  height: 25px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding-left: 10px;
  padding-right: 10px;
  color: #333;
  position: absolute;
  justify-items: center;
}

.gantt-chart__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
  margin-left: 1.5rem !important;
}

.gantt-chart__row:nth-child(1n) .gantt-chart__bar {
  background: linear-gradient(to right, #f6e384, #de7b32) !important;
}
/*.gantt-chart__row:nth-child(2n) .gantt-chart__bar {
        background: linear-gradient(to right, #84d9d2, #07cdae) !important;
    }
    .gantt-chart__row:nth-child(4n) .gantt-chart__bar {
        background: linear-gradient(to right, #90caf9, #047edf 99%) !important;
        
    }
    .gantt-chart__row:nth-child(3n) .gantt-chart__bar {
        background: linear-gradient(to right, #ffbf96, #fe7096) !important;
    }*/

.gantt-chart__bar:hover {
  cursor: pointer;
}

.gantt-chart__row:nth-child(1n) .gantt-chart__bar:hover {
  background: linear-gradient(to right, #de7b32, #de7b32) !important;
}
/*.gantt-chart__row:nth-child(2n) .gantt-chart__bar:hover{
        background: linear-gradient(to right, #07cdae, #07cdae) !important;
    }
    .gantt-chart__row:nth-child(4n) .gantt-chart__bar:hover{
        background: linear-gradient(to right, #047edf, #047edf 99%) !important;
    }
    .gantt-chart__row:nth-child(3n) .gantt-chart__bar:hover{
        background: linear-gradient(to right, #fe7096, #fe7096) !important;
    }*/

.gantt-chart__bar .btn {
  position: absolute;
  margin-left: 100%;
  width: max-content;
}

.gantt-chart__bar .btn span {
  max-width: 0;
  -webkit-transition: max-width 1s;
  transition: max-width 1s;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
}

.gantt-chart__bar .btn:hover span {
  max-width: 15rem;
  margin-left: 0.5rem !important;
}

.gantt-chart__number {
  position: absolute;
  left: 0;
  padding-top: 2px;
  padding-bottom: 2px;
  background: rgba(100, 100, 100, 0.4);
  padding-right: 4px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  color: #333;
  font-weight: 600;
  border-right: 1px solid #333;
  font-family: monospace;
  width: 28px;
  text-align: center;
}

.gantt-chart__padding_number {
  padding-left: 20px;
}
</style>